import React, { useState } from 'react';
import { IconButton, Icon, Box } from '@mui/material';
import useStyles from './styles';
import clsx from 'clsx';
import { get } from 'global/lib/lodash';
import { Loader } from 'global/styles';
import { executePrint } from '../../utils';
import { useView } from '../../hooks/useView';

export * from './print-view';

// eslint-disable-next-line import/no-anonymous-default-export
export default (props) => {
  const classes = useStyles();
  const [loading, setLoading] = useState(false);
  const [loaded, setLoaded] = useState(false);
  const [toggled, setToggled] = useState(false);
  const { isDark, toggleTheme } = useView();

  const print = () => {
    if (loaded) {
      executePrint();
      if (toggled) {
        toggleTheme();
        setToggled(false);
      }
      setLoaded(false);
      return props.onFinish && props.onFinish();
    }

    const onPrint = get(props, 'onPrint');
    if (onPrint) {
      setLoading(true);
      onPrint()
        .then(() => {
          setLoaded(true);
          setToggled(isDark);
          isDark && toggleTheme();
        })
        .catch((err) => {
          setLoaded(false);
          toggled && toggleTheme();
          setToggled(false);
        }).finally(() => {
          setLoading(false);
        });
    } else {
      executePrint();
    }
  };

  const getIcon = () => {
    if (loading) {
      return <Loader size={18} />;
    } else if (loaded) {
      return (
        <div className={classes.printIconContainer}>
          <Icon>print</Icon>
          <Icon className={classes.checkIcon}>check_circle</Icon>
        </div>
      );
    } else {
      return <Icon>print</Icon>;
    }
  };

  return (
    <Box displayPrint="none" className={clsx(classes.container, props.className)}>
      <IconButton onClick={print} color={'inherit'} size="large">
        {getIcon()}
      </IconButton>
    </Box>
  );
};
